module.exports = " <i class=\"fa fa-4x {{class}}\" ></i>\r\n\r\n"